import capitalize from 'underscore.string/capitalize'
import moment from 'moment'
import Plot from 'react-plotly.js'
import React, { memo } from 'react'
import styled from 'styled-components'

import { chartOptions } from 'pages/Dashboard/CustomerAdoptionCard/chartOptions'

import { longDate } from 'helpers/formatters'

import { color } from 'styles/colors'
import { NoData, PanelTitle } from 'styles/shared'

import { CustomerAdoption } from 'types/CustomerAdoption'

type Props = {
  customers: Array<CustomerAdoption>
  variant: 'new' | 'existing'
  timeSpanInDays: number
  onChartLoadCallback: (labels) => void;
}

const Chart = ({ variant, customers, timeSpanInDays, onChartLoadCallback }: Props) => {
  const plotOptions = chartOptions(variant, customers, timeSpanInDays)

  const onChartLoad = () => {
    onChartLoadCallback(plotOptions.data.labels)
  }

  return (
    <S.Chart>
      {plotOptions.hasData && (
        <S.ChartContainer>
          <S.Plot
            layout={plotOptions.layout}
            data={[plotOptions.data]}
            config={plotOptions.config}
            onInitialized={onChartLoad}
            onUpdate={onChartLoad}
            useResizeHandler
          />
        </S.ChartContainer>
      )}
      {!plotOptions.hasData && <S.NoData><h2>NO DATA FOR THIS TIME PERIOD</h2></S.NoData>}

      <S.ChartDetails>
        <S.ChartTitle>{`${capitalize(variant)} Customers` }</S.ChartTitle>

        <S.Info>Customers created</S.Info>
        <S.Info>{`${variant === 'new' ? 'on or after' : 'before'} ${longDate(moment().subtract(timeSpanInDays, 'days'))}`}</S.Info>
      </S.ChartDetails>
    </S.Chart>
  )
}

export default memo(Chart)

const S = {
  Chart: styled.div`
    display: grid;
    grid-template-columns: repeat(1, minmax(250px, 1fr));
    text-align: center;
    justify-items: center;
  `,
  Plot: styled(Plot)`
    width: 100%;
    height: 100%;
  `,
  ChartContainer: styled.div`
    width: 100%;
    height: 100%;
    min-height: 250px;
  `,
  NoData: styled(NoData)`
    padding: 5em 0 5em 0;
  `,
  ChartDetails: styled.div`
    display: flex;
    flex-direction: column;
    margin-top: auto;
    padding-top: 15px;
  `,
  ChartName: styled.span`
    font-size: 24px;
    font-weight: bold;
  `,
  Info: styled.span`
    font-weight: 400;
    color: ${color('ancillaryText')};
  `,
  ChartTitle: styled(PanelTitle)`
    color: ${color('primaryText')};
  `
}
